import { IDictionary } from 'models/dictionary';
import { AuditLogModules, EAuditLogEvents, EventTypes } from 'pages/AuditLogPage/helpers';
import { getEnumByValue } from 'utils/enum';

const moduleFilters: Record<AuditLogModules, EAuditLogEvents[]> = {
  [AuditLogModules.LEGAL_ENTITIES]: [
    EAuditLogEvents.ADD_LE_INDIVIDUAL,
    EAuditLogEvents.EDIT_LE_INDIVIDUAL,
    EAuditLogEvents.DELETE_LE_INDIVIDUAL,
    EAuditLogEvents.DATA_EXPORT_LE_INDIVIDUAL,
    EAuditLogEvents.VIEW_LE_INDIVIDUAL_DETAILS,
    EAuditLogEvents.SEARCH_FOR_LE_INDIVIDUAL,
    EAuditLogEvents.ADD_LE_INDIVIDUAL_CONTACT,
    EAuditLogEvents.EDIT_LE_INDIVIDUAL_CONTACT,
    EAuditLogEvents.DELETE_LE_INDIVIDUAL_CONTACT,
    EAuditLogEvents.ACTIVATE_LE_INDIVIDUAL,
    EAuditLogEvents.DEACTIVATE_LE_INDIVIDUAL,
    EAuditLogEvents.EDIT_LE_PHOTO_GALLERY,
    EAuditLogEvents.DOWNLOAD_LE_PHOTO_GALLERY,
    EAuditLogEvents.ADD_LE_ORGANIZATION,
    EAuditLogEvents.EDIT_LE_ORGANIZATION,
    EAuditLogEvents.DELETE_LE_ORGANIZATION,
    EAuditLogEvents.DATA_EXPORT_LE_ORGANIZATION,
    EAuditLogEvents.VIEW_LE_ORGANIZATION_DETAILS,
    EAuditLogEvents.SEARCH_FOR_LE_ORGANISATION,
    EAuditLogEvents.ADD_LE_ORGANIZATION_CONTACT,
    EAuditLogEvents.EDIT_LE_ORGANIZATION_CONTACT,
    EAuditLogEvents.DELETE_LE_ORGANIZATION_CONTACT,
    EAuditLogEvents.ACTIVATE_LE_ORGANIZATION,
    EAuditLogEvents.DEACTIVATE_LE_ORGANIZATION,
  ],
  [AuditLogModules.FIREARMS]: [
    EAuditLogEvents.ADD_FIREARM,
    EAuditLogEvents.EDIT_FIREARM,
    EAuditLogEvents.DISABLE_FIREARM,
    EAuditLogEvents.DATA_EXPORT_FIREARM,
    EAuditLogEvents.ADD_FIREARM_TO_FRT_LOCAL,
    EAuditLogEvents.EDIT_FIREARM_FROM_FRT_LOCAL,
    EAuditLogEvents.VIEW_FIREARM_DETAILS,
    EAuditLogEvents.SEARCH_FOR_FIREARM,
    EAuditLogEvents.EDIT_FIREARM_PHOTO_GALLERY,
    EAuditLogEvents.DOWNLOAD_FIREARM_PHOTO_GALLERY,
  ],
  [AuditLogModules.TRANSACTIONS]: [
    EAuditLogEvents.ADD_TRANSACTION,
    EAuditLogEvents.DISCARD_TRANSACTION,
    EAuditLogEvents.DATA_EXPORT_TRANSACTIONS,
    EAuditLogEvents.VIEW_TRANSACTION_DETAILS,
    EAuditLogEvents.SEARCH_FOR_TRANSACTION,
  ],
  [AuditLogModules.ADMINISTRATION]: [
    EAuditLogEvents.ADD_ROLE,
    EAuditLogEvents.EDIT_ROLE,
    EAuditLogEvents.DELETE_ROLE,
    EAuditLogEvents.ADD_USER,
    EAuditLogEvents.EDIT_USER,
    EAuditLogEvents.DELETE_USER,
    EAuditLogEvents.DEACTIVATE_USER,
    EAuditLogEvents.ACTIVATE_USER,
    EAuditLogEvents.SEARCH_FOR_USER,
    EAuditLogEvents.ADD_VALUE_TO_DICTIONARY,
    EAuditLogEvents.DEACTIVATE_DICTIONARY_VALUE,
    EAuditLogEvents.ACTIVATE_DICTIONARY_VALUE,
    EAuditLogEvents.ACTIVATE_E_TRACE_AUTO_GENERATION,
    EAuditLogEvents.DEACTIVATE_E_TRACE_AUTO_GENERATION,
    EAuditLogEvents.ACTIVATE_I_ARMS_AUTO_GENERATION,
    EAuditLogEvents.DEACTIVATE_I_ARMS_AUTO_GENERATION,
    EAuditLogEvents.ACTIVATE_TWO_FACTOR_AUTHENTICATION,
    EAuditLogEvents.DEACTIVATE_TWO_FACTOR_AUTHENTICATION,
    EAuditLogEvents.ACTIVATE_AUTHENTICATOR,
    EAuditLogEvents.DEACTIVATE_AUTHENTICATOR,
    EAuditLogEvents.ACTIVATE_TWO_FACTOR_EMAIL_AUTHENTICATOR,
    EAuditLogEvents.DEACTIVATE_TWO_FACTOR_EMAIL_AUTHENTICATOR,
    EAuditLogEvents.EDIT_INVALID_LOGIN_ATTEMPTS,
    EAuditLogEvents.EDIT_MINUTES_IN_BAN,
    EAuditLogEvents.EDIT_DATE_FORMAT,
    EAuditLogEvents.EDIT_TWO_FACTOR_CHARTS_TIME_PERIOD,
    EAuditLogEvents.EDIT_CURRENCY,
    EAuditLogEvents.EDIT_MEASUREMENT,
    EAuditLogEvents.EDIT_RENEWING_PERIOD_BEFORE_LICENCE_EXPIRATION,
    EAuditLogEvents.EDIT_NOTIFICATIONS_FOR_UPCOMING_LICENSE_EXPIRATION,
    EAuditLogEvents.EDIT_HEADER_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_SUB_HEADER_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_LOGO_1_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_LOGO_2_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_LOGO_3_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
  ],
  [AuditLogModules.CUSTOM_FIELDS]: [
    EAuditLogEvents.ADD_CUSTOM_FIELD,
    EAuditLogEvents.EDIT_CUSTOM_FIELD,
    EAuditLogEvents.DELETE_CUSTOM_FIELD,
    EAuditLogEvents.DISABLE_CUSTOM_FIELD,
    EAuditLogEvents.ENABLE_CUSTOM_FIELD,
  ],
  [AuditLogModules.AUTHENTICATION]: [
    EAuditLogEvents.LOGIN_SUCCESS,
    EAuditLogEvents.LOGIN_FAILURE,
    EAuditLogEvents.LOGIN_2FA_FAILURE,
    EAuditLogEvents.LOGIN_OFFLINE_2FA_FAILURE,
    EAuditLogEvents.LOGOUT_SUCCESS,
    EAuditLogEvents.PASSWORD_CHANGE_SUCCESS,
    EAuditLogEvents.BLOCK_ACCOUNT,
    EAuditLogEvents.NEW_PASSWORD_GENERATION,
  ],
  [AuditLogModules.ANCILLARIES]: [
    EAuditLogEvents.ADD_ANCILLARY_ACCESSORY,
    EAuditLogEvents.EDIT_ANCILLARY_ACCESSORY,
    EAuditLogEvents.DISABLE_ANCILLARY_ACCESSORY,
    EAuditLogEvents.DATA_EXPORT_ANCILLARY_ACCESSORY,
    EAuditLogEvents.VIEW_CONTROLLED_ACCESSORIES_DETAILS,
    EAuditLogEvents.SEARCH_FOR_CONTROLLED_ACCESSORIES,
    EAuditLogEvents.ADD_ANCILLARY_AMMUNITION,
    EAuditLogEvents.EDIT_ANCILLARY_AMMUNITION,
    EAuditLogEvents.DISABLE_ANCILLARY_AMMUNITION,
    EAuditLogEvents.DATA_EXPORT_ANCILLARY_AMMUNITION,
    EAuditLogEvents.VIEW_AMMUNITION_DETAILS,
    EAuditLogEvents.SEARCH_FOR_AMMUNITION,
    EAuditLogEvents.ADD_ANCILLARY_COMPONENT,
    EAuditLogEvents.EDIT_ANCILLARY_COMPONENT,
    EAuditLogEvents.DISABLE_ANCILLARY_COMPONENT,
    EAuditLogEvents.DATA_EXPORT_ANCILLARY_COMPONENT,
    EAuditLogEvents.VIEW_ESSENTIAL_COMPONENTS_DETAILS,
    EAuditLogEvents.SEARCH_FOR_ESSENTIAL_COMPONENTS,
    EAuditLogEvents.EDIT_ANCILLAIES_PHOTO_GALLERY,
    EAuditLogEvents.DOWNLOAD_ANCILLAIES_PHOTO_GALLERY,
    EAuditLogEvents.ADD_ANCILLARY_ACCESSORY_TO_ART_LOCAL,
    EAuditLogEvents.EDIT_ANCILLARY_ACCESSORY_FROM_ART_LOCAL,
    EAuditLogEvents.ADD_ANCILLARY_AMMUNITION_TO_ART_LOCAL,
    EAuditLogEvents.EDIT_ANCILLARY_AMMUNITION_FROM_ART_LOCAL,
    EAuditLogEvents.ADD_ANCILLARY_COMPONENT_TO_ART_LOCAL,
    EAuditLogEvents.EDIT_ANCILLARY_COMPONENT_FROM_ART_LOCAL,
  ],
  [AuditLogModules.AUDIT_LOG]: [
    EAuditLogEvents.OPEN_AUDIT_LOG,
    EAuditLogEvents.SEARCH_AUDIT_LOG,
    EAuditLogEvents.DATA_EXPORT_AUDIT_LOG,
  ],
  [AuditLogModules.API_KEYS]: [
    EAuditLogEvents.ADD_API_KEY,
    EAuditLogEvents.EDIT_API_KEY,
    EAuditLogEvents.DELETE_API_KEY,
    EAuditLogEvents.DEACTIVATE_API_KEY,
    EAuditLogEvents.ACTIVATE_API_KEY,
  ],
  [AuditLogModules.WEAPON_LICENCE_CONFIGURATOR]: [
    EAuditLogEvents.ADD_LICENCE_DEFINITION,
    EAuditLogEvents.EDIT_LICENCE_DEFINITION,
    EAuditLogEvents.DELETE_LICENCE_DEFINITION,
    EAuditLogEvents.PUBLISH_LICENCE_DEFINITION,
    EAuditLogEvents.UNPUBLISH_LICENCE_DEFINITION,
    EAuditLogEvents.SEARCH_FOR_LICENCE_DEFINITION,
    EAuditLogEvents.VIEW_LICENCE_DEFINITION,
    EAuditLogEvents.ADD_APPLICATION_PROCESS,
    EAuditLogEvents.EDIT_APPLICATION_PROCESS,
    EAuditLogEvents.ACTIVATE_APPLICATION_PROCESS,
    EAuditLogEvents.DEACTIVATE_APPLICATION_PROCESS,
  ],
  [AuditLogModules.WEAPON_LICENCES]: [
    EAuditLogEvents.ADD_LICENCE,
    EAuditLogEvents.VARY_LICENCE,
    EAuditLogEvents.EDIT_SCHEDULED_LICENCE,
    EAuditLogEvents.SUSPEND_LICENCE,
    EAuditLogEvents.REVOKE_LICENCE,
    EAuditLogEvents.REACTIVATE_LICENCE,
    EAuditLogEvents.SURRENDER_LICENCE,
    EAuditLogEvents.EXPIRE_LICENCE,
    EAuditLogEvents.RENEW_LICENCE,
    EAuditLogEvents.VIEW_LICENCE_DETAILS,
    EAuditLogEvents.SEARCH_FOR_LICENCE,
    EAuditLogEvents.ACTIVATE_LICENCE,
    EAuditLogEvents.DATA_EXPORT_LICENCE,
    EAuditLogEvents.LINKING_WEAPON_LICENCE,
    EAuditLogEvents.UPDATE_PAYMENT_STATUS,
    EAuditLogEvents.CANCEL_LICENCE,
  ],
  [AuditLogModules.GLOBAL_SEARCH]: [
    EAuditLogEvents.LE_INDIVIDUALS_GLOBAL_SEARCH,
    EAuditLogEvents.LE_ORGANIZATIONS_GLOBAL_SEARCH,
    EAuditLogEvents.FIREARMS_GLOBAL_SEARCH,
    EAuditLogEvents.TRANSACTIONS_GLOBAL_SEARCH,
    EAuditLogEvents.ACCESSORIES_GLOBAL_SEARCH,
    EAuditLogEvents.AMMUNITION_GLOBAL_SEARCH,
    EAuditLogEvents.COMPONENTS_GLOBAL_SEARCH,
    EAuditLogEvents.USERS_GLOBAL_SEARCH,
    EAuditLogEvents.LICENCES_GLOBAL_SEARCH,
  ],
  [AuditLogModules.CASE_MANAGEMENT]: [
    EAuditLogEvents.VIEW_CASE_DETAILS,
    EAuditLogEvents.SEARCH_FOR_CASE,
  ],
};

const eventTypeFilters: Record<EventTypes, EAuditLogEvents[]> = {
  [EventTypes.ADD]: [
    EAuditLogEvents.ADD_LE_INDIVIDUAL,
    EAuditLogEvents.ADD_LE_INDIVIDUAL_CONTACT,
    EAuditLogEvents.ADD_LE_ORGANIZATION,
    EAuditLogEvents.ADD_LE_ORGANIZATION_CONTACT,
    EAuditLogEvents.ADD_FIREARM,
    EAuditLogEvents.ADD_FIREARM_TO_FRT_LOCAL,
    EAuditLogEvents.ADD_TRANSACTION,
    EAuditLogEvents.ADD_ROLE,
    EAuditLogEvents.ADD_USER,
    EAuditLogEvents.ADD_VALUE_TO_DICTIONARY,
    EAuditLogEvents.ADD_CUSTOM_FIELD,
    EAuditLogEvents.ADD_ANCILLARY_ACCESSORY,
    EAuditLogEvents.ADD_ANCILLARY_AMMUNITION,
    EAuditLogEvents.ADD_ANCILLARY_COMPONENT,
    EAuditLogEvents.ADD_ANCILLARY_ACCESSORY_TO_ART_LOCAL,
    EAuditLogEvents.ADD_ANCILLARY_AMMUNITION_TO_ART_LOCAL,
    EAuditLogEvents.ADD_ANCILLARY_COMPONENT_TO_ART_LOCAL,
    EAuditLogEvents.ADD_API_KEY,
    EAuditLogEvents.ADD_LICENCE_DEFINITION,
    EAuditLogEvents.ADD_LICENCE,
  ],
  [EventTypes.EDIT]: [
    EAuditLogEvents.EDIT_LE_INDIVIDUAL,
    EAuditLogEvents.EDIT_LE_INDIVIDUAL_CONTACT,
    EAuditLogEvents.EDIT_LE_ORGANIZATION,
    EAuditLogEvents.EDIT_LE_ORGANIZATION_CONTACT,
    EAuditLogEvents.EDIT_LE_PHOTO_GALLERY,
    EAuditLogEvents.EDIT_FIREARM,
    EAuditLogEvents.EDIT_FIREARM_FROM_FRT_LOCAL,
    EAuditLogEvents.EDIT_FIREARM_PHOTO_GALLERY,
    EAuditLogEvents.EDIT_ROLE,
    EAuditLogEvents.EDIT_USER,
    EAuditLogEvents.EDIT_CUSTOM_FIELD,
    EAuditLogEvents.EDIT_ANCILLARY_ACCESSORY,
    EAuditLogEvents.EDIT_ANCILLARY_AMMUNITION,
    EAuditLogEvents.EDIT_ANCILLARY_COMPONENT,
    EAuditLogEvents.EDIT_ANCILLARY_ACCESSORY_FROM_ART_LOCAL,
    EAuditLogEvents.EDIT_ANCILLARY_AMMUNITION_FROM_ART_LOCAL,
    EAuditLogEvents.EDIT_ANCILLARY_COMPONENT_FROM_ART_LOCAL,
    EAuditLogEvents.EDIT_API_KEY,
    EAuditLogEvents.EDIT_LICENCE_DEFINITION,
    EAuditLogEvents.EDIT_RENEWING_PERIOD_BEFORE_LICENCE_EXPIRATION,
    EAuditLogEvents.EDIT_NOTIFICATIONS_FOR_UPCOMING_LICENSE_EXPIRATION,
    EAuditLogEvents.EDIT_INVALID_LOGIN_ATTEMPTS,
    EAuditLogEvents.EDIT_MINUTES_IN_BAN,
    EAuditLogEvents.EDIT_DATE_FORMAT,
    EAuditLogEvents.EDIT_TWO_FACTOR_CHARTS_TIME_PERIOD,
    EAuditLogEvents.EDIT_HEADER_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_SUB_HEADER_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_LOGO_1_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_LOGO_2_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_LOGO_3_ON_LOGIN_PAGE_AND_LOGOS_SETUP,
    EAuditLogEvents.EDIT_CURRENCY,
    EAuditLogEvents.EDIT_MEASUREMENT,
    EAuditLogEvents.EDIT_LICENCE_DEFINITION,
    EAuditLogEvents.UPDATE_PAYMENT_STATUS,
    EAuditLogEvents.EDIT_SCHEDULED_LICENCE,
    EAuditLogEvents.EDIT_APPLICATION_PROCESS,
  ],
  [EventTypes.DELETE]: [
    EAuditLogEvents.DELETE_LE_INDIVIDUAL,
    EAuditLogEvents.DELETE_LE_INDIVIDUAL_CONTACT,
    EAuditLogEvents.DELETE_LE_ORGANIZATION,
    EAuditLogEvents.DELETE_LE_ORGANIZATION_CONTACT,
    EAuditLogEvents.DELETE_ROLE,
    EAuditLogEvents.DELETE_USER,
    EAuditLogEvents.DELETE_CUSTOM_FIELD,
    EAuditLogEvents.DELETE_API_KEY,
    EAuditLogEvents.DELETE_LICENCE_DEFINITION,
  ],
  [EventTypes.DATA_EXPORT]: [
    EAuditLogEvents.DATA_EXPORT_LE_INDIVIDUAL,
    EAuditLogEvents.DATA_EXPORT_LE_ORGANIZATION,
    EAuditLogEvents.DATA_EXPORT_FIREARM,
    EAuditLogEvents.DATA_EXPORT_TRANSACTIONS,
    EAuditLogEvents.DATA_EXPORT_ANCILLARY_ACCESSORY,
    EAuditLogEvents.DATA_EXPORT_ANCILLARY_AMMUNITION,
    EAuditLogEvents.DATA_EXPORT_ANCILLARY_COMPONENT,
    EAuditLogEvents.DATA_EXPORT_AUDIT_LOG,
    EAuditLogEvents.DATA_EXPORT_LICENCE,
  ],
  [EventTypes.ENABLE]: [EAuditLogEvents.ENABLE_CUSTOM_FIELD],
  [EventTypes.REENABLE]: [
    EAuditLogEvents.ACTIVATE_LE_ORGANIZATION,
    EAuditLogEvents.ACTIVATE_LE_INDIVIDUAL,
  ],
  [EventTypes.DISABLE]: [
    EAuditLogEvents.DISABLE_FIREARM,
    EAuditLogEvents.DEACTIVATE_LE_ORGANIZATION,
    EAuditLogEvents.DEACTIVATE_LE_INDIVIDUAL,
    EAuditLogEvents.DISABLE_CUSTOM_FIELD,
    EAuditLogEvents.DISABLE_ANCILLARY_ACCESSORY,
    EAuditLogEvents.DISABLE_ANCILLARY_AMMUNITION,
    EAuditLogEvents.DISABLE_ANCILLARY_COMPONENT,
  ],
  [EventTypes.DISCARD]: [EAuditLogEvents.DISCARD_TRANSACTION],
  [EventTypes.ACTIVATE]: [
    EAuditLogEvents.ACTIVATE_DICTIONARY_VALUE,
    EAuditLogEvents.ACTIVATE_E_TRACE_AUTO_GENERATION,
    EAuditLogEvents.ACTIVATE_I_ARMS_AUTO_GENERATION,
    EAuditLogEvents.ACTIVATE_TWO_FACTOR_AUTHENTICATION,
    EAuditLogEvents.ACTIVATE_AUTHENTICATOR,
    EAuditLogEvents.ACTIVATE_USER,
    EAuditLogEvents.ACTIVATE_API_KEY,
    EAuditLogEvents.ACTIVATE_LICENCE,
    EAuditLogEvents.ACTIVATE_TWO_FACTOR_EMAIL_AUTHENTICATOR,
    EAuditLogEvents.ACTIVATE_APPLICATION_PROCESS,
  ],
  [EventTypes.DEACTIVATE]: [
    EAuditLogEvents.DEACTIVATE_DICTIONARY_VALUE,
    EAuditLogEvents.DEACTIVATE_E_TRACE_AUTO_GENERATION,
    EAuditLogEvents.DEACTIVATE_I_ARMS_AUTO_GENERATION,
    EAuditLogEvents.DEACTIVATE_TWO_FACTOR_AUTHENTICATION,
    EAuditLogEvents.DEACTIVATE_AUTHENTICATOR,
    EAuditLogEvents.DEACTIVATE_USER,
    EAuditLogEvents.DEACTIVATE_API_KEY,
    EAuditLogEvents.DEACTIVATE_TWO_FACTOR_EMAIL_AUTHENTICATOR,
    EAuditLogEvents.DEACTIVATE_APPLICATION_PROCESS,
  ],
  [EventTypes.LOGIN]: [
    EAuditLogEvents.LOGIN_SUCCESS,
    EAuditLogEvents.LOGIN_FAILURE,
    EAuditLogEvents.LOGIN_2FA_FAILURE,
    EAuditLogEvents.LOGIN_OFFLINE_2FA_FAILURE,
  ],
  [EventTypes.LOGOUT]: [EAuditLogEvents.LOGOUT_SUCCESS],
  [EventTypes.BLOCK]: [EAuditLogEvents.BLOCK_ACCOUNT],
  [EventTypes.PASSWORD_CHANGE]: [
    EAuditLogEvents.PASSWORD_CHANGE_SUCCESS,
    EAuditLogEvents.NEW_PASSWORD_GENERATION,
  ],
  [EventTypes.VIEW]: [
    EAuditLogEvents.VIEW_LE_INDIVIDUAL_DETAILS,
    EAuditLogEvents.VIEW_LE_ORGANIZATION_DETAILS,
    EAuditLogEvents.VIEW_FIREARM_DETAILS,
    EAuditLogEvents.VIEW_TRANSACTION_DETAILS,
    EAuditLogEvents.VIEW_CONTROLLED_ACCESSORIES_DETAILS,
    EAuditLogEvents.VIEW_AMMUNITION_DETAILS,
    EAuditLogEvents.VIEW_ESSENTIAL_COMPONENTS_DETAILS,
    EAuditLogEvents.VIEW_LICENCE_DETAILS,
    EAuditLogEvents.VIEW_LICENCE_DEFINITION,
    EAuditLogEvents.OPEN_AUDIT_LOG,
    EAuditLogEvents.VIEW_CASE_DETAILS,
  ],
  [EventTypes.SEARCH]: [
    EAuditLogEvents.SEARCH_FOR_LE_INDIVIDUAL,
    EAuditLogEvents.SEARCH_FOR_LE_ORGANISATION,
    EAuditLogEvents.SEARCH_FOR_FIREARM,
    EAuditLogEvents.SEARCH_FOR_TRANSACTION,
    EAuditLogEvents.SEARCH_FOR_CONTROLLED_ACCESSORIES,
    EAuditLogEvents.SEARCH_FOR_AMMUNITION,
    EAuditLogEvents.SEARCH_FOR_ESSENTIAL_COMPONENTS,
    EAuditLogEvents.SEARCH_FOR_LICENCE,
    EAuditLogEvents.SEARCH_FOR_LICENCE_DEFINITION,
    EAuditLogEvents.SEARCH_AUDIT_LOG,
    EAuditLogEvents.LE_INDIVIDUALS_GLOBAL_SEARCH,
    EAuditLogEvents.LE_ORGANIZATIONS_GLOBAL_SEARCH,
    EAuditLogEvents.FIREARMS_GLOBAL_SEARCH,
    EAuditLogEvents.TRANSACTIONS_GLOBAL_SEARCH,
    EAuditLogEvents.ACCESSORIES_GLOBAL_SEARCH,
    EAuditLogEvents.AMMUNITION_GLOBAL_SEARCH,
    EAuditLogEvents.COMPONENTS_GLOBAL_SEARCH,
    EAuditLogEvents.USERS_GLOBAL_SEARCH,
    EAuditLogEvents.LICENCES_GLOBAL_SEARCH,
    EAuditLogEvents.SEARCH_FOR_USER,
    EAuditLogEvents.SEARCH_FOR_CASE,
  ],
  [EventTypes.PUBLISH]: [EAuditLogEvents.PUBLISH_LICENCE_DEFINITION],
  [EventTypes.UNPUBLISH]: [EAuditLogEvents.UNPUBLISH_LICENCE_DEFINITION],
  [EventTypes.CREATE]: [EAuditLogEvents.ADD_LICENCE, EAuditLogEvents.ADD_APPLICATION_PROCESS],
  [EventTypes.VARY]: [EAuditLogEvents.VARY_LICENCE],
  [EventTypes.SUSPEND]: [EAuditLogEvents.SUSPEND_LICENCE],
  [EventTypes.REVOKE]: [EAuditLogEvents.REVOKE_LICENCE],
  [EventTypes.SURRENDER]: [EAuditLogEvents.SURRENDER_LICENCE],
  [EventTypes.REACTIVATE]: [EAuditLogEvents.REACTIVATE_LICENCE],
  [EventTypes.EXPIRE]: [EAuditLogEvents.EXPIRE_LICENCE],
  [EventTypes.RENEW]: [EAuditLogEvents.RENEW_LICENCE],
  [EventTypes.LINK]: [EAuditLogEvents.LINKING_WEAPON_LICENCE],
  [EventTypes.CANCEL]: [EAuditLogEvents.CANCEL_LICENCE],
};

export const filterEventName = (
  selectedModules: string[],
  selectedEventTypes: string[],
  eventNames: IDictionary[] | null,
) => {
  if (!eventNames) return eventNames;

  const validTypes = selectedEventTypes.length
    ? selectedEventTypes.map((eventType) => getEnumByValue(EventTypes, eventType))
    : [];

  const validModules = selectedModules.length
    ? selectedModules.map((module) => getEnumByValue(AuditLogModules, module))
    : [];

  const filteredNames: IDictionary[] = [];

  if (selectedModules.length > 0) {
    validModules.forEach((module) => {
      const moduleEvents = moduleFilters[module];
      if (moduleEvents) {
        const filteredEvents = eventNames.filter((event) =>
          moduleEvents.includes(getEnumByValue(EAuditLogEvents, event.uniqueId.toString())),
        );
        filteredNames.push(...filteredEvents);
      }
    });
  }

  if (selectedModules.length === 0 && selectedEventTypes.length > 0) {
    validTypes.forEach((type) => {
      const typeEvents = eventTypeFilters[type];
      if (typeEvents) {
        const filteredEvents = eventNames.filter((event) =>
          typeEvents.includes(getEnumByValue(EAuditLogEvents, event.uniqueId.toString())),
        );
        filteredNames.push(...filteredEvents);
      }
    });
  } else if (selectedEventTypes.length > 0) {
    const eventNamesIntersection: IDictionary[] = [];
    validTypes.forEach((type) => {
      const typeEvents = eventTypeFilters[type];
      if (typeEvents) {
        const filteredEvents = filteredNames.filter((event) =>
          typeEvents.includes(getEnumByValue(EAuditLogEvents, event.uniqueId.toString())),
        );
        eventNamesIntersection.push(...filteredEvents);
      }
    });
    return eventNamesIntersection;
  }

  return filteredNames.length > 0 ? filteredNames : eventNames;
};
